/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useContext } from 'react';
import { LanguageContext } from '../../../libs/Context';
import { MediaContext } from '..';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import CustomSearch from '../../../UiComponents/Search/CustomSearch';

const CoustomSearch = (props:any) =>
{
	const { tab } = props;
	const { language } = useContext(LanguageContext);
	const userId = useParams()?.userId;
	const { mediaState, setMediaState } = useContext(MediaContext);
	const { folderData, sharedData, employeeData, trashData } = useSelector((state:any) => state?.mymediakit?.mediaKitData);
	const visibleFolderData = tab === 0 ? folderData : tab === 1 ? sharedData : tab === 2 ? employeeData : trashData;

	const handleChange = (e:any) =>
	{
		setMediaState({ type: 'updateSearch', payload: e.target.value.replace(/^\s+/, '') });
	};

	return (<>
		{/* <Stack sx={{ width: mobile ? 'var(--percent100)' : 600 }}>
			<div className='flexCol'>
				<Autocomplete
					freeSolo
					options={[]}
					id='free-solo-2-demo'
					size='small'
					disableClearable
					disabled={mediaState?.searchValue === '' && visibleFolderData?.length <= 0}
					inputValue={mediaState?.searchValue}
					onInputChange={handleChange}
					renderInput={(params) => (
						<TextField
							{...params}
							value={mediaState?.srchVal}
							placeholder={(tab === 0 || userId) ? `${language?.searchinMediaDrive}` : tab === 1 ? `${language.searchShareItems}` : tab === 2 ? `${language?.searchinEmployees}` : tab === 4 ? `${language?.searchTemplate}` : `${language?.searchinTrash}`}
							InputProps={{
								...params.InputProps,
								type           : 'search',
								startAdornment : (
									<InputAdornment position='start'>
										<SearchIcon />
									</InputAdornment>
								),
								endAdornment : (
									<InputAdornment position='end'>
									</InputAdornment>
								)
							}}
							className='modeGray'
						/>
					)}
				/>
			</div>
		</Stack> */}
		<CustomSearch
			value={mediaState?.searchValue}
			handleChange={handleChange}
			placeholder={(tab === 0 || userId) ? `${language?.searchinMediaDrive}` : tab === 1 ? `${language.searchShareItems}` : tab === 2 ? `${language?.searchinEmployees}` : tab === 4 ? `${language?.searchTemplate}` : `${language?.searchinTrash}`}
			disabled={mediaState?.searchValue === '' && visibleFolderData?.length <= 0}
		/>
	</>);
};

export default CoustomSearch;